import React from 'react';

import './SliderMainItem.scss';

interface SliderMainItemProps {
  children: React.ReactElement;
  caption?: string;
}

const SliderMainItem = ({ children, caption }: SliderMainItemProps) => {
  return (
    <figure styleName="item" key={children.props}>
      <div styleName="item__file-container">
        {children}
      </div>
    </figure>
  );
};

export default SliderMainItem;
